import React from 'react';
import { Users, DollarSign, CheckCircle, Clock } from 'lucide-react';

const TrustIndicators = () => {
  const indicators = [
    {
      icon: Users,
      value: '1,100+',
      label: 'Happy Clients',
      description: 'Loans lodged and growing',
    },
    {
      icon: DollarSign,
      value: '$500M+',
      label: 'Loans Processed',
      description: 'Successfully settled across Australia',
    },
    {
      icon: CheckCircle,
      value: '80+',
      label: 'Access to 80+ Lenders',
      description: 'Banks, non-bank and specialist lenders',
    },
    {
      icon: Clock,
      value: '3h',
      label: 'Average Response',
      description: 'Typical time to first reply',
    },
  ];

  return (
    <section className="py-16 bg-white" data-testid="trust-indicators-section">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {indicators.map((indicator, index) => {
            const Icon = indicator.icon;
            return (
              <div
                key={index}
                className="text-center group"
                data-testid={`trust-indicator-${index}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#99DF63]/10 rounded-full mb-4 group-hover:bg-[#99DF63]/20 transition-all">
                  <Icon className="w-8 h-8 text-[#00594C]" />
                </div>
                <div className="text-3xl font-bold text-[#00594C] mb-2">
                  {indicator.value}
                </div>
                <div className="font-semibold text-gray-900 mb-1">
                  {indicator.label}
                </div>
                <div className="text-sm text-gray-600">
                  {indicator.description}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;